// 定义内容
export default {
  label: {
    one1: '账号密码登录',
    two2: '手机号登录'
  },
  link: {
    one3: '',
    two4: ''
  },
  copyright: {
    one5: '版权所有：上药集团常州药业股份有限公司',
    two6: ''
  },
  account: {
    accountPlaceholder1: '用户名',
    accountPlaceholder2: '密码',
    accountPlaceholder3: '请输入验证码',
    accountBtnText: '登 录'
  },
  mobile: {
    placeholder1: '请输入手机号',
    placeholder2: '请输入验证码',
    codeText: '获取验证码',
    btnText: '登 录'
  },
  signInText: '欢迎回来！'
}
